/** Seed list for company meetings (mirrors REST list item shape). */
const STATUSES = ['scheduled', 'completed', 'cancelled', 'failed'];
const CHANNELS = ['Teams', 'WhatsApp', 'Web'];
const PROVIDERS = ['Microsoft', 'Google'];
const BOOKING = ['Bot', 'Manual', 'Calendar sync'];

const ORG = [
  { id: 'u-1', name: 'Sara Al-Hinai', email: 'sara@acme.example' },
  { id: 'u-2', name: 'Ahmed Al-Balushi', email: 'ahmed@acme.example' },
  { id: 'u-3', name: 'Priya Menon', email: 'priya@acme.example' },
  { id: 'u-4', name: 'James Cole', email: 'james@acme.example' },
];

function buildMeeting(i) {
  const start = new Date(Date.now() - i * 7200000 + (i % 3) * 3600000);
  const durationMin = [30, 45, 60][i % 3];
  const end = new Date(start.getTime() + durationMin * 60000);
  const org = ORG[i % ORG.length];
  const status = STATUSES[i % 4];
  return {
    id: `mtg-${3000 + i}`,
    subject: `Meeting ${i + 1}: QBR / Sync — ${['Alpha', 'Beta', 'Gamma'][i % 3]}`,
    startAt: start.toISOString(),
    endAt: end.toISOString(),
    durationMin,
    organizerId: org.id,
    organizerName: org.name,
    organizerEmail: org.email,
    attendeeCount: 3 + (i % 8),
    provider: PROVIDERS[i % 2],
    channel: CHANNELS[i % 3],
    status,
    roomResource: i % 5 === 0 ? `Room ${(i % 4) + 1}` : null,
    bookingMethod: BOOKING[i % 3],
    notes: i % 4 === 0 ? 'Agenda: budget, roadmap, risks.' : 'Weekly sync.',
    joinLink: `https://meet.example/${3000 + i}`,
    pendingMOM: status === 'completed' && i % 7 === 0,
  };
}

export const meetingsListSeed = Array.from({ length: 42 }, (_, i) => buildMeeting(i));

export const directoryUsersForMeetings = [
  ...ORG,
  { id: 'u-5', name: 'Omar Said', email: 'omar@acme.example' },
  { id: 'u-6', name: 'Fatima Noor', email: 'fatima@acme.example' },
  { id: 'u-7', name: 'Li Wei', email: 'li@acme.example' },
];

/** Full detail for a meeting (merged with list row in API). */
export function meetingDetailExtras(meetingId, row) {
  const base = row || meetingsListSeed[0];
  const attendees = [
    { name: 'Alice Khan', email: 'alice@acme.example', response: 'Accepted', availability: 'Available' },
    { name: 'Bob Smith', email: 'bob@acme.example', response: 'Declined', availability: 'Conflict' },
    { name: 'Carol Diaz', email: 'carol@acme.example', response: 'No response', availability: 'Available' },
    { name: 'Dan Lee', email: 'dan@acme.example', response: 'Accepted', availability: 'Conflict' },
  ];
  const transcriptStatus = base.status === 'failed' ? 'failed' : ['pending', 'processing', 'ready'][Number(base.id?.slice(-1) || 0) % 3];
  return {
    id: meetingId || base.id,
    timeline: [
      { type: 'created', at: new Date(Date.parse(base.startAt) - 86400000 * 2).toISOString(), message: 'Meeting created', actor: base.organizerName },
      { type: 'reminder', at: new Date(Date.parse(base.startAt) - 900000).toISOString(), message: 'Reminder sent to 4 attendees (T-15min)', actor: 'System' },
      { type: 'update', at: new Date(Date.parse(base.startAt) - 3600000).toISOString(), message: 'Meeting time updated', actor: 'Sara Al-Hinai' },
      { type: 'transcript', at: new Date(Date.parse(base.startAt) + 600000).toISOString(), message: 'Transcript pull started', actor: 'Bot' },
      { type: 'mom', at: new Date(Date.parse(base.startAt) + 1200000).toISOString(), message: 'MOM generated (draft)', actor: 'AI' },
    ],
    notifications: [
      { id: 'n1', recipient: 'alice@acme.example', channel: 'Email', type: 'Reminder', status: 'Delivered', sentAt: new Date(Date.parse(base.startAt) - 900000).toISOString() },
      { id: 'n2', recipient: 'bob@acme.example', channel: 'Teams', type: 'Reminder', status: 'Failed', sentAt: new Date(Date.parse(base.startAt) - 890000).toISOString(), failureReason: 'User offline' },
    ],
    transcript: {
      status: transcriptStatus,
      meetingId: meetingId || base.id,
      errorMessage: transcriptStatus === 'failed' ? 'Provider returned 503' : null,
    },
    attendees,
  };
}

export const availabilitySlotsSeed = [
  { id: 's1', time: '09:00', day: 'Mon', score: 'all-available', conflicts: [] },
  { id: 's2', time: '10:30', day: 'Mon', score: 'partial', conflicts: ['Sara has another meeting at this time'] },
  { id: 's3', time: '14:00', day: 'Tue', score: 'all-available', conflicts: [] },
  { id: 's4', time: '11:00', day: 'Wed', score: 'conflict', conflicts: ['Bob has another meeting', 'Room 2 booked'] },
  { id: 's5', time: '15:30', day: 'Wed', score: 'partial', conflicts: ['Carol tentative on another invite'] },
];

export const alternativeSlotsSeed = [
  { id: 'a1', time: '16:00', day: 'Wed', score: 'all-available', conflicts: [] },
  { id: 'a2', time: '09:30', day: 'Thu', score: 'partial', conflicts: ['One conflict'] },
];
